import _isEmpty from 'lodash/isEmpty';
import _pickBy from 'lodash/pickBy'
import { EVENTS_MESA } from 'constants/values/giftTableWap';

export const transformListParams = (params = {}) => {
  if (_isEmpty(params)) return {};

  return {
    ...params,
    page_num: params.page || '',
    order_by: params.orderBy || '',
    items_per_page: params.size || '',
  };
};

export const transformListRes = (list = [], pagination) => ({
  list,
  mobileList: list,
  totalElements: pagination.total_items,
  totalPages: pagination.total_pages,
  params: {
    page: pagination.current_page,
    size: pagination.items_per_page,
    mobilePage: pagination.current_page,
    mobileSize: pagination.items_per_page,
  },
});

export const transformListParamsWap = (params = {}) => {
  if (_isEmpty(params)) return {};

  const paramsWap = _pickBy({
    tipo: params.type_id ? EVENTS_MESA[params.type_id]?.idWap : null,
    fechaEvento: params.gifttable_date || null,
    nombre1: params.celebrate_name || null,
    numEvento: params.gifttable_id || null,
    page: `${params.page}` || '1'
  })

  return {
    data: window.btoa(JSON.stringify(paramsWap))
  };
};
